import address from '@stores/address';
import cart from '@stores/cart';
import loader from '@stores/loader';
import myInfo from '@stores/myInfo';
import order from '@stores/order';
import popup from '@stores/popup';
import restaurant from '@stores/restaurant';
import socket from '@stores/socket';
import event from '@stores/event';

export default {
  popup,
  myInfo,
  loader,
  address,
  restaurant,
  order,
  socket,
  cart,
  event,
};
